import { Deployment } from '@liveauctioneers/hammer-ui-payments/types';

import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';

import type {
    CatalogsNearMeBoundingBoxRequest,
    CatalogsNearMeCityStateRequest,
    CatalogsNearMeResponse,
} from './catalogsNearMe.types';

/**
 * Fetch catalogs near a specific location using bounding box coordinates
 * @function fetchCatalogsNearMeByBoundingBox
 * @category Catalog Management API
 * @param {CatalogsNearMeBoundingBoxRequest & { deployment: Deployment | 'test' | '' }}
 * @see https://catalog-management-DEPLOYMENT.liveauctioneers.com/cms/catalogs/near-me
 */
export const fetchCatalogsNearMeByBoundingBox = ({
    deployment,
    hasFreeLocalPickup,
    insideBoundingBox,
    isTopRated,
    page,
    pageSize,
    searchTerm,
}: CatalogsNearMeBoundingBoxRequest & { deployment: Deployment | 'test' | '' }) =>
    new Promise<CatalogsNearMeResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'near-me-v2',
            deployment,
            path: ApiHosts.CatalogManagementCMS,
            queryParams: {
                insideBoundingBox,
                page,
                ...(pageSize && { pageSize }),
                ...(hasFreeLocalPickup && { hasFreeLocalPickup }),
                ...(isTopRated && { isTopRated }),
                ...(searchTerm && { searchTerm }),
            },
        });

        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

/**
 * Fetch catalogs near a specific location using city and state
 * @function fetchCatalogsNearMeByCityState
 * @category Catalog Management API
 * @param {CatalogsNearMeCityStateRequest & { deployment: Deployment | 'test' | '' }}
 * @see https://catalog-management-DEPLOYMENT.liveauctioneers.com/cms/catalogs/near-me
 */
export const fetchCatalogsNearMeByCityState = ({
    city,
    deployment,
    page,
    pageSize,
    state,
}: CatalogsNearMeCityStateRequest & { deployment: Deployment | 'test' | '' }) =>
    new Promise<CatalogsNearMeResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'near-me-v2',
            deployment,
            path: ApiHosts.CatalogManagementCMS,
            queryParams: {
                city,
                page,
                ...(pageSize && { pageSize }),
                state,
            },
        });

        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
